<h4 mat-dialog-title>
    Ajouter une structure de recherche
</h4>
<div mat-dialog-content>

  <form [formGroup]="firstFormGroup">
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label for="label">Libellé de la structure<span class="star">*</span>:</label>
          <input type="text" class="form-control" id="label" formControlName="label" >
        </div>
      </div>
      <div class="col-md-4">
          <label for="label">Sigle:</label>
          <input type="text" class="form-control" id="sigle" formControlName="sigle" >
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <p><strong>{{ 'front.editLaboReference.directeurUniteAutres' | translate }}</strong></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="directeurCivilite">Civilité <span class="star">*</span>: </label>
          <mat-select class="form-control" name="directeurCivilite" id="directeurCivilite" formControlName="civilite" [compareWith]="compareByLetter"  required>
            <mat-option value="f">Madame</mat-option>
            <mat-option value="m">Monsieur</mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="directeur_nom">Nom <span class="star">*</span>:</label>
          <input class="form-control" name="directeur_nom" id="directeur_nom" type="text" formControlName="directeur_nom"  />
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="directeur_prenom">Prénom <span class="star">*</span>:</label>
          <input class="form-control" name="directeur_prenom" id="directeur_prenom" type="text" formControlName="directeur_prenom" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
            <p><strong>{{ 'general.adresseEtablissement' | translate }}</strong></p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <app-geocoder (place)="nouvelleAdresse = $event"></app-geocoder>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
            <mat-checkbox class="form-control" style="line-height: 40px" name="CLCC" id="CLCC" formControlName="CLCC"> CLCC </mat-checkbox>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <mat-checkbox class="form-control" style="line-height: 40px" name="APHP" id="APHP" formControlName="APHP"> APHP </mat-checkbox>
        </div>
      </div>
    </div>




    </form>


</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="null">Annuler</button>
  <button mat-raised-button color="primary"
          (click)="addLabo()">
    Ajouter cette structure
  </button>
</div>
